import React from "react";

import { TextCenter } from "src/common/components/TextAlign";

import secondPng from "./second.png";
import thirdPng from "./third.png";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>
			A verzióban az alábbiak szerint változik a rendszerből automatikusan
			küldött e-mail értesítés funkció.
		</h1>
		<p>
			A jövőben automatikus e-mail értesítések kerülnek kiküldésre a
			rendszerből amennyiben a chat üzenőfalon (Állapotváltozás áttekintő)
			új bejegyzés kerül felvételre. A funkció használatához kérjük
			olvassa el az alábbi leírást:
		</p>
		<ol>
			<li>
				Amennyiben új vizsgálat kerül feltöltésre a már folyamatban lévő
				páciensek esetén, azt kérjük a chatben jelezni szíveskedjenek!
			</li>
			<li>
				A Dialízis állomások a betegfelvételkor a Páciens regisztrációs
				felületen kérjük állítsák be az orvos / nővér / adminisztrátor
				felhasználókat, akik értesítést fognak kapni a bizottsági
				oldalon történt FYRMS bejegyzésekről. A módosítást utólag is
				megtehetik a páciens adatlapján, amit a páciens adatai áttekintő
				nézetének a jobb felső sarkában a ‘Páciens adatainak
				szerkesztése’ ikonra kattintva érhetnek el.
				<TextCenter>
					<img src={secondPng} width="90%" />
				</TextCenter>
			</li>
			<li>
				Amennyiben a chat (Állapotváltozás áttekintő) felületre
				bejegyzés történik a referáló centrum vagy pedig a Várólista
				bizottság részéről, akkor ennek tényéről a bejegyzés szerzőjén
				kívül értesítést fognak kapni a páciens adatlapján (Páciens
				szerkesztése) beállított ‘Adathozzáféréssel rendelkező
				felhasználók’.
				<TextCenter>
					<img src={thirdPng} width="90%" />
				</TextCenter>
			</li>
			<li>
				A rendszer lejáró vizsgálatokról küldött e-mail beállításai nem
				változnak.
			</li>
		</ol>
		<p>
			A FYRMS folyamatban lévő fejlesztései a továbbiakban reményeink
			szerint még inkább megkönnyítik a rendszer használatát.
		</p>
	</section>
);
